<script setup lang="ts">
import { useObserversStore } from '@/store/observers/observers'

import type { Category } from '@/types/api/api-v3/category'

import MainCategoryCard from '@/components/Main/Category/MainCategoryCard.vue'

type Props = {
  simpleCategories: Category[]
}

defineProps<Props>()

const observersStore = useObserversStore()

const categoryListElement = ref<HTMLElement | null>(null)

const observe = () => {
  if (!categoryListElement.value || !window) return

  useIntersectionObserver(
    categoryListElement.value,
    {
      threshold: [0, 0.5, 1],
      rootMargin: '-150px 0px 0px',
    },
    ([{ isIntersecting, boundingClientRect }]) => {
      const state =
        !isIntersecting &&
        boundingClientRect.top !== 0 &&
        boundingClientRect.top <= window.innerHeight

      observersStore.setCategoryListState(state)
    },
  )
}

onMounted(() => {
  setTimeout(() => {
    observe()
  }, 300)
})

onBeforeUnmount(() => observersStore.setCategoryListState(false))
</script>

<template>
  <nav
    ref="categoryListElement"
    class="category-list"
    itemscope
    itemtype="http://schema.org/SiteNavigationElement"
  >
    <the-slider
      :slide-width="90"
      :space-between="12"
      :slides-to-scroll="5"
      overlay="md"
    >
      <main-category-card
        v-for="category in simpleCategories"
        :key="category.slug"
        class="category-list__card"
        :category="category"
      />
    </the-slider>
  </nav>
</template>

<style lang="scss" scoped>
.category-list {
  &__card {
    width: 90px;
  }
}
</style>
